import { FilterField } from "~/features/filter";
import { coincidenceList } from "~/pages/DNM/options";

import { useDnmDealerOptions } from "./optionsHooks";

type Translate = (key: string) => string;

/**
 * Поля фильтра страницы DNM. Имена полей — ключи query-параметров URL,
 * из которых страница собирает строку params для useGetDNMData.
 * Поле `date` — месячный пикер, хранит строку `yyyy-MM`, из которой
 * страница собирает параметр `month=yyyy.MM` для useGetDNMData.
 */
export const dnmFilterFields = (t: Translate): FilterField[] => [
  {
    name: "fio",
    type: "input",
    label: t("dnm.fio"),
  },
  {
    name: "position",
    type: "input",
    label: t("dnm.position"),
  },
  {
    name: "coincidence",
    type: "select",
    label: t("dnm.coincidence"),
    placeholder: t("common.not_selected"),
    options: coincidenceList,
  },
  {
    name: "date",
    type: "datePicker",
    label: t("dnm.datePicker"),
    picker: "month",
  },
  {
    name: "dealerSelect",
    type: "select",
    label: t("dnm.dc"),
    placeholder: t("common.not_selected"),
    multiple: true,
    optionsHook: useDnmDealerOptions,
    newRow: true,
    span: 2,
  },
];
